/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamRevisionPublishBotexamidQueryResponse,
  GetApiV1ExamRevisionPublishBotexamidPathParams,
  GetApiV1ExamRevisionPublishBotexamid400,
  GetApiV1ExamRevisionPublishBotexamid401,
  GetApiV1ExamRevisionPublishBotexamid404,
  GetApiV1ExamRevisionPublishBotexamid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionPublishBotexamid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamRevisionPublishBotexamid } from "../../clients/examRevisionController/getApiV1ExamRevisionPublishBotexamid.ts";

export const getApiV1ExamRevisionPublishBotexamidQueryKey = (
  botExamId: GetApiV1ExamRevisionPublishBotexamidPathParams["botExamId"],
) =>
  [
    {
      url: "/api/v1/exam/revision/publish/:botExamId",
      params: { botExamId: botExamId },
    },
  ] as const;

export type GetApiV1ExamRevisionPublishBotexamidQueryKey = ReturnType<
  typeof getApiV1ExamRevisionPublishBotexamidQueryKey
>;

export function getApiV1ExamRevisionPublishBotexamidQueryOptions(
  botExamId: GetApiV1ExamRevisionPublishBotexamidPathParams["botExamId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamRevisionPublishBotexamidQueryKey(botExamId);
  return queryOptions<
    GetApiV1ExamRevisionPublishBotexamidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionPublishBotexamid400
      | GetApiV1ExamRevisionPublishBotexamid401
      | GetApiV1ExamRevisionPublishBotexamid404
      | GetApiV1ExamRevisionPublishBotexamid500
    >,
    GetApiV1ExamRevisionPublishBotexamidQueryResponse,
    typeof queryKey
  >({
    enabled: !!botExamId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamRevisionPublishBotexamid(botExamId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados necessários para a tela de publicação de uma avaliação gerada por IA, incluindo as informações da prova (BotExam) e as opções de configuração para a publicação principal e, se aplicável, para a publicação da avaliação docente. **(Requer Authorization para autenticação)**
 * @summary Obter dados para publicação de avaliação gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/publish/:botExamId}
 */
export function useGetApiV1ExamRevisionPublishBotexamid<
  TData = GetApiV1ExamRevisionPublishBotexamidQueryResponse,
  TQueryData = GetApiV1ExamRevisionPublishBotexamidQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamRevisionPublishBotexamidQueryKey,
>(
  botExamId: GetApiV1ExamRevisionPublishBotexamidPathParams["botExamId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamRevisionPublishBotexamidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamRevisionPublishBotexamid400
          | GetApiV1ExamRevisionPublishBotexamid401
          | GetApiV1ExamRevisionPublishBotexamid404
          | GetApiV1ExamRevisionPublishBotexamid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamRevisionPublishBotexamidQueryKey(botExamId);

  const query = useQuery(
    {
      ...getApiV1ExamRevisionPublishBotexamidQueryOptions(botExamId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionPublishBotexamid400
      | GetApiV1ExamRevisionPublishBotexamid401
      | GetApiV1ExamRevisionPublishBotexamid404
      | GetApiV1ExamRevisionPublishBotexamid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
